
import { CharacterConfig, ObjectConfig, TextObjectConfig } from "../../../Phaser/types/config";
import { defineActionBlocks } from "./action";
import { defineAttributeBlocks } from "./attribute";
import { defineControlBlocks } from "./control";
import { defineEventBlocks } from "./event";
import { defineFonctionsBlocks } from "./fonctions";
import { defineInputBlocks } from "./Input";
import { defineLogicBlocks } from "./logic";
import { defineMathBlocks } from "./math";
import { defineMovementBlocks } from "./mouvement";
import { defineMovementsBlocks } from "./mouvement_multicharacter";
import { defineTextBlocks } from "./text";
import { defineVariablesBlocks } from "./variable";

export function initAllCustomBlocks(
  characters: CharacterConfig[] | undefined,
  objetcs: ObjectConfig[] | undefined,
  texts: TextObjectConfig[] | undefined,
) {
  defineMovementBlocks();
  characters && defineMovementsBlocks(characters);
  characters && defineActionBlocks(characters);
  defineAttributeBlocks();
  characters && objetcs && defineEventBlocks(characters, objetcs);
  characters && objetcs && texts && defineFonctionsBlocks(characters, objetcs, texts);
  defineInputBlocks();
  defineMathBlocks();
  defineLogicBlocks();
  defineControlBlocks();
  defineVariablesBlocks();
  texts && defineTextBlocks(texts);
}
